import React from 'react';

import Text, { TextType, TextProps } from 'components/typography/text';

const ActionMedium: React.FC<React.PropsWithChildren<TextProps>> = (props) => (
  <Text
    type={TextType.ACTION_MEDIUM}
    isExtended={props.isExtended}
    isResponsive={props.isResponsive || true}
    {...props}
  >
    {props.children}
  </Text>
);

export default ActionMedium;
